import React from "react";

/* ---------- Device hero illustrations ---------- */

const CasinoScreen = () => {
    // Casino game tile symbols (cycle through)
    const tiles = [
        { sym: "7", color: "#E63946" },
        { sym: "★", color: "#F3E5AB" },
        { sym: "♦", color: "#D4AF37" },
        { sym: "♣", color: "#fff" },
        { sym: "♠", color: "#fff" },
        { sym: "♥", color: "#E63946" },
        { sym: "₿", color: "#F3E5AB" },
        { sym: "💎", color: "#22DBA0" },
        { sym: "21", color: "#D4AF37" },
        { sym: "BAR", color: "#F3E5AB" },
        { sym: "👑", color: "#D4AF37" },
        { sym: "🎰", color: "#fff" },
    ];

    return (
        <g>
            <rect width="100%" height="100%" fill="#0a0a0a" />
            {/* top bar */}
            <rect width="100%" height="14" fill="#16161a" />
            <text x="8" y="11" fill="#D4AF37" fontSize="8" fontWeight="800">
                CASINOBIAT.ONLINE
            </text>
            {/* coin balance */}
            <g transform="translate(108 4)">
                <rect width="20" height="8" rx="4" fill="#1a1500" stroke="#D4AF37" strokeOpacity="0.5" strokeWidth="0.5" />
                <circle cx="3" cy="4" r="1.5" fill="#D4AF37" />
                <text x="7" y="6.5" fontSize="4.5" fill="#D4AF37" fontWeight="700">
                    9,840
                </text>
            </g>

            {/* hero strip */}
            <rect x="0" y="14" width="100%" height="40" fill="#D4AF37" opacity="0.12" />
            <text x="50%" y="24" textAnchor="middle" fill="#D4AF37" fontSize="6.5" fontWeight="700">
                Türkiye&apos;nin En Büyük
            </text>
            <text x="50%" y="34" textAnchor="middle" fill="#D4AF37" fontSize="6.5" fontWeight="700">
                Casino Ve Bet sitesi ile
            </text>
            <text x="50%" y="48" textAnchor="middle" fill="#fff" fontSize="8" fontWeight="800">
                Sende Kazan
            </text>

            {/* JACKPOT ticker */}
            <g transform="translate(6 58)">
                <rect width="118" height="13" rx="3" fill="#1a1500" stroke="#D4AF37" strokeOpacity="0.5" strokeWidth="0.5" />
                <text x="3" y="9" fontSize="5" fill="#E63946" fontWeight="800">
                    JACKPOT
                </text>
                <text x="26" y="9" fontSize="6" fill="#F3E5AB" fontWeight="800">
                    <animate
                        attributeName="opacity"
                        values="1;0.5;1"
                        dur="1.5s"
                        repeatCount="indefinite"
                    />
                    ₺ 1.284.917,53
                </text>
                <circle cx="112" cy="6.5" r="2" fill="#E63946">
                    <animate
                        attributeName="opacity"
                        values="1;0.2;1"
                        dur="1s"
                        repeatCount="indefinite"
                    />
                </circle>
            </g>

            {/* game cards grid with symbols */}
            <g transform="translate(0 76)">
                {tiles.map((t, i) => {
                    const col = i % 4;
                    const row = Math.floor(i / 4);
                    const hot = [0, 5, 10].includes(i);
                    return (
                        <g key={i} transform={`translate(${6 + col * 31} ${row * 26})`}>
                            <rect
                                width="28"
                                height="22"
                                rx="3"
                                fill="#1a1a1c"
                                stroke={hot ? "#D4AF37" : "#D4AF37"}
                                strokeOpacity={hot ? "0.7" : "0.18"}
                            />
                            <text
                                x="14"
                                y="15"
                                textAnchor="middle"
                                fontSize={t.sym.length > 1 ? "7" : "11"}
                                fill={t.color}
                                fontWeight="800"
                            >
                                {t.sym}
                                {hot && (
                                    <animate
                                        attributeName="opacity"
                                        values="0.6;1;0.6"
                                        dur={`${1 + (i % 3) * 0.3}s`}
                                        repeatCount="indefinite"
                                    />
                                )}
                            </text>
                            {hot && (
                                <circle cx="24" cy="3" r="1.5" fill="#E63946">
                                    <animate
                                        attributeName="opacity"
                                        values="1;0.3;1"
                                        dur="0.9s"
                                        repeatCount="indefinite"
                                    />
                                </circle>
                            )}
                        </g>
                    );
                })}
            </g>

            {/* Live winners feed */}
            <g transform="translate(6 160)">
                <text x="0" y="5" fontSize="5" fill="#D4AF37" fontWeight="800">
                    CANLI KAZANANLAR
                </text>
                <line x1="0" y1="7" x2="118" y2="7" stroke="#D4AF37" strokeOpacity="0.2" />

                {[
                    { user: "Mehmet T.", game: "Sweet Bonanza", win: "₺ 12.480" },
                    { user: "Ayşe K.", game: "Gates of Olympus", win: "₺ 8.720" },
                    { user: "Cem D.", game: "Aviator x14.21", win: "₺ 22.350" },
                ].map((w, i) => (
                    <g key={i} transform={`translate(0 ${11 + i * 9})`}>
                        <circle cx="3" cy="3" r="2" fill="#D4AF37" opacity="0.6" />
                        <text x="8" y="5" fontSize="4.5" fill="#fff">
                            {w.user}
                        </text>
                        <text x="38" y="5" fontSize="4" fill="#fff" opacity="0.5">
                            {w.game}
                        </text>
                        <text x="118" y="5" textAnchor="end" fontSize="4.5" fill="#22DBA0" fontWeight="700">
                            +{w.win}
                        </text>
                    </g>
                ))}
            </g>

            {/* Promotional banner */}
            <g transform="translate(6 200)">
                <rect width="118" height="22" rx="3" fill="#1a1500" stroke="#D4AF37" strokeOpacity="0.5" strokeWidth="0.5" />
                {/* Shine animation */}
                <rect width="20" height="22" rx="3" fill="#D4AF37" opacity="0.3">
                    <animate
                        attributeName="x"
                        values="-20; 120"
                        dur="2.5s"
                        repeatCount="indefinite"
                    />
                </rect>
                <text x="6" y="10" fontSize="6" fill="#F3E5AB" fontWeight="800">
                    %100 HOŞ GELDİN
                </text>
                <text x="6" y="17" fontSize="5" fill="#fff" opacity="0.7">
                    İlk yatırımına özel
                </text>
                <rect x="78" y="6" width="34" height="11" rx="5.5" fill="#D4AF37" />
                <text x="95" y="13.5" textAnchor="middle" fontSize="5.5" fill="#000" fontWeight="800">
                    AL
                </text>
            </g>

            {/* Bottom nav bar */}
            <g transform="translate(0 230)">
                <rect width="100%" height="20" fill="#16161a" />
                {[
                    { lbl: "Slot", active: true },
                    { lbl: "Canlı" },
                    { lbl: "Spor" },
                    { lbl: "Profil" },
                ].map((n, i) => (
                    <g key={i} transform={`translate(${15 + i * 32} 6)`}>
                        <circle cx="0" cy="3" r="3" fill={n.active ? "#D4AF37" : "#2a2a2c"} />
                        <text
                            x="0"
                            y="14"
                            textAnchor="middle"
                            fontSize="4.5"
                            fill={n.active ? "#D4AF37" : "#888"}
                            fontWeight="700"
                        >
                            {n.lbl}
                        </text>
                    </g>
                ))}
            </g>
        </g>
    );
};

export const DesktopHero = () => (
    <div className="relative w-full max-w-md mx-auto">
        <svg viewBox="0 0 320 220" className="w-full h-auto">
            {/* monitor body */}
            <rect x="20" y="10" width="280" height="170" rx="8" fill="#c8c8d0" />
            <rect x="32" y="22" width="256" height="146" rx="3" fill="#0a0a0a" />
            <svg
                x="32"
                y="22"
                width="256"
                height="146"
                viewBox="0 0 130 110"
                preserveAspectRatio="xMidYMid slice"
            >
                <CasinoScreen />
            </svg>
            {/* stand */}
            <path d="M130 180 L190 180 L200 200 L120 200 Z" fill="#b0b0ba" />
            <rect x="100" y="200" width="120" height="6" rx="3" fill="#9b9ba6" />
        </svg>
    </div>
);

export const PhoneHero = ({ variant = "ios" }) => (
    <div className="relative w-full max-w-[260px] mx-auto">
        <svg viewBox="0 0 220 420" className="w-full h-auto">
            {/* phone body */}
            <rect width="220" height="420" rx="34" fill="#1a1a1c" />
            <rect x="6" y="6" width="208" height="408" rx="28" fill="#000" />
            {/* notch / camera */}
            {variant === "ios" ? (
                <rect x="86" y="10" width="48" height="8" rx="4" fill="#0a0a0a" />
            ) : (
                <circle cx="110" cy="14" r="3" fill="#0a0a0a" />
            )}
            {/* screen */}
            <svg x="14" y="28" width="192" height="376" viewBox="0 0 130 250" preserveAspectRatio="xMidYMid slice">
                <CasinoScreen />
            </svg>
        </svg>
    </div>
);

const HERO_MAP = {
    desktop: DesktopHero,
    iphone: () => <PhoneHero variant="ios" />,
    android: () => <PhoneHero variant="android" />,
};

export const DeviceHero = ({ name }) => {
    const Comp = HERO_MAP[name];
    if (!Comp) return null;
    return <Comp />;
};
